import { c as _c } from "react/compiler-runtime";
import { Icon, MapPinIcon, Typography } from "@/shared/ui/atoms";
import { HospitalInfoComponentProps } from "@/entities/hospital/model/types";
import { useTranslations } from "next-intl";
interface HospitalInfoProps {
  hospitalInfo: HospitalInfoComponentProps;
  isShowFullAddress?: boolean;
}
const HospitalInfo = t0 => {
  const $ = _c(26);
  const {
    hospitalInfo,
    isShowFullAddress: t1
  } = t0;
  const isShowFullAddress = t1 === undefined ? true : t1;
  const {
    name,
    fullAddress,
    score,
    totalReviewCount,
    primaryTreatment
  } = hospitalInfo;
  const t = useTranslations();
  let t2;
  if ($[0] !== name) {
    t2 = <Typography as="h1" size={24} lineHeight={28} className="font-bold text-gray-900">{name}</Typography>;
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon src="/icons/star.svg" alt="star" width={24} height={24} className="ml-2" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== score) {
    t4 = <Typography size={20} lineHeight={22} className="font-semibold ml-0.5">{score}</Typography>;
    $[3] = score;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className="flex items-center mb-2">{t2}{t3}{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== primaryTreatment) {
    t6 = <Typography size={14} lineHeight={18} className="text-gray-700 font-medium">{primaryTreatment}</Typography>;
    $[8] = primaryTreatment;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="w-[2px] h-[2px] bg-gray-600 rounded-full my-auto" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("info.review");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8 || $[14] !== totalReviewCount) {
    t9 = <Typography size={14} lineHeight={18} className="flex gap-1 text-gray-700 font-medium">{t8} {totalReviewCount}</Typography>;
    $[13] = t8;
    $[14] = totalReviewCount;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className="flex items-center gap-1 text-gray-700 mb-[14px]">{t6}{t7}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== fullAddress || $[20] !== isShowFullAddress) {
    t11 = isShowFullAddress && <div className="flex items-start gap-2"><MapPinIcon size={16} className="text-gray-300 flex-shrink-0" /><Typography size={14} lineHeight={18} className="text-gray-700 whitespace-pre-wrap break-keep">{fullAddress}</Typography></div>;
    $[19] = fullAddress;
    $[20] = isShowFullAddress;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t5) {
    t12 = <div>{t5}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default HospitalInfo;